export const VIDEO_PLAYER_CONTROL_TYPES = ({
  PLAY: 'PLAY',
  PAUSE: 'PAUSE',
  FORWARD: 'FORWARD',
  BACKWARD: 'BACKWARD',
  SKIP_TO_FIRST: 'SKIP_TO_FIRST',
  SKIP_TO_LAST: 'SKIP_TO_LAST',
  JUMP_FORWARD: 'JUMP_FORWARD',
  JUMP_BACKWARD: 'JUMP_BACKWARD'
} as const);
export const SPEED_OPTIONS = [2, 1.75, 1.5, 1.25, 1, 0.75, 0.5, 0.25, 0.1];
export const BUTTON_SIZE = 12;
export const ZOOM_MIN = 90;
export const ZOOM_MAX = 500;
export const FRAME_STEP_SIZE = {
  DEFAULT: 1,
  TEN_FRAMES: 10
};
export const FRAME_SLIDER_WIDTH = '154px';
export const LABELS = ({
  STARTING_FRAME: 'Starting frame',
  PREVIOUS_FRAME: 'Previous frame',
  NEXT_FRAME: 'Next frame',
  LAST_FRAME: 'Last frame',
  PLAY: 'Play',
  PAUSE: 'Pause',
  SWITCH_TO_TIME: 'Switch to time',
  SWITCH_TO_FRAME: 'Switch to frame'
} as const);